import { render, staticRenderFns } from "./BasicInput.vue?vue&type=template&id=5c7a84ff&"
import script from "./BasicInput.vue?vue&type=script&lang=js&"
export * from "./BasicInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports